import { mapSuburbs } from '@/mocks/projects';

export default function ProjectMapSection() {
  return (
    <section className="relative py-28 md:py-36 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-stone-100 via-cream-50 to-stone-100/50"></div>
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: 'radial-gradient(circle at 30% 50%, rgba(201,122,74,0.3) 0%, transparent 50%), radial-gradient(circle at 70% 50%, rgba(201,122,74,0.2) 0%, transparent 50%)',
        }}
      />

      <div className="relative z-10 max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="mb-16 md:mb-20">
          <p className="font-mono text-xs text-stone-400 tracking-[0.25em] uppercase mb-5 whitespace-nowrap">
            Where We Work
          </p>
          <h2 className="font-serif text-4xl md:text-6xl text-charcoal-900 leading-tight mb-4">
            Delivering across Melbourne
          </h2>
          <p className="text-stone-500 text-base max-w-xl">
            Real work across greater Melbourne and the Yarra Valley.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
          <div className="lg:col-span-2">
            <div className="relative w-full aspect-[4/3] overflow-hidden group">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d100769.94732777364!2d144.95!3d-37.80!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sau!4v1"
                width="100%"
                height="100%"
                style={{ border: 0, filter: 'grayscale(100%) contrast(90%)' }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Melbourne project locations"
              ></iframe>
              <div className="absolute inset-0 pointer-events-none border border-stone-300/60"></div>
              <div className="absolute inset-0 pointer-events-none bg-charcoal-900/0 group-hover:bg-charcoal-900/5 transition-colors duration-500"></div>
            </div>
          </div>

          <div className="flex flex-col justify-center">
            <p className="font-mono text-xs text-stone-400 tracking-[0.2em] uppercase mb-6 whitespace-nowrap">
              Project Suburbs
            </p>
            <ul className="space-y-5">
              {mapSuburbs.map((suburb) => (
                <li key={suburb.name} className="flex items-center gap-3 group cursor-default">
                  <div className="w-2 h-2 bg-terracotta-500 shrink-0 transition-all duration-300 group-hover:w-3 group-hover:h-3 group-hover:bg-terracotta-600"></div>
                  <span className="font-serif text-xl text-charcoal-800 transition-colors duration-300 group-hover:text-terracotta-600">
                    {suburb.name}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
